import { useQuery } from 'react-query'
import { listarVersoesModelo } from '../../../core/_requests'

/**
 * Versões do modelo da plataforma, separadas em publicada (destaque no cabeçalho) e demais
 * (tabela). Em cache pela chave: cabeçalho e tabela compartilham a mesma requisição.
 */
export const useVersoesModelo = () => {
  const query = useQuery(['protocolos-triagem', 'modelo-versoes'], () => listarVersoesModelo(), {
    retry: false,
  })

  const lista = query.data ?? []
  const publicada = lista.find((versao) => versao.situacao === 'PUBLICADA')
  const demais = lista.filter((versao) => versao.situacao !== 'PUBLICADA')

  return { ...query, publicada, demais }
}
